import { useEffect, useState } from "react";
import { Plus, X } from "lucide-react";
import { toast } from "sonner";
import { listProdotti, setPiano } from "./clubApi";
import { Btn, Card, inputCls } from "./ui";

export default function PlanEditor({ cliente, onDone, onCancel }) {
  const [cat, setCat] = useState([]);
  const [items, setItems] = useState(cliente.piano.prodotti.map((p) => ({ ...p })));
  const [note, setNote] = useState(cliente.piano.note || "");
  const [durata, setDurata] = useState(cliente.piano.durata_giorni || 30);
  const [durataManual, setDurataManual] = useState(cliente.piano.confermato === true);
  const [pick, setPick] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { listProdotti().then((r) => setCat(r.filter((p) => p.attivo))).catch(() => {}); }, []);
  useEffect(() => {
    if (!durataManual && items.length) setDurata(Math.max(...items.map((p) => Number(p.durata_giorni) || 0)) || 30);
  }, [items, durataManual]);

  const add = () => {
    const p = cat.find((x) => x.codice === pick);
    if (!p || items.some((i) => i.codice === p.codice)) return;
    setItems([...items, { codice: p.codice, nome: p.nome, dose: p.dose, durata_giorni: p.durata_giorni }]); setPick("");
  };
  const save = async () => {
    if (items.length === 0) return toast.error("Aggiungi almeno un prodotto");
    setBusy(true);
    try { await setPiano(cliente.id, { prodotti: items, note, confermato: true, durata_giorni: Number(durata) || 30 }); toast.success("Percorso confermato: ora è visibile al cliente"); onDone(); } catch { toast.error("Errore nel salvataggio"); }
    setBusy(false);
  };
  return (
    <Card className="mt-3 space-y-4" data-testid="plan-editor">
      <div className="space-y-2">
        {items.map((p, i) => (
          <div key={p.codice || i} className="rounded-2xl bg-[#0E0E10] border border-[#232328] p-3" data-testid={`plan-item-${p.codice}`}>
            <div className="flex items-start justify-between gap-2">
              <p className="font-medium text-sm">{p.nome}</p>
              <button onClick={() => setItems(items.filter((_, j) => j !== i))} className="text-[#9A948A] hover:text-[#ff9a9e]" data-testid={`plan-remove-${p.codice}`}><X size={16} /></button>
            </div>
            <div className="mt-2 grid grid-cols-[1fr_84px] gap-2">
              <input className={`${inputCls} py-2 text-xs`} value={p.dose || ""} placeholder="Come si usa" onChange={(e) => setItems(items.map((x, j) => (j === i ? { ...x, dose: e.target.value } : x)))} />
              <input className={`${inputCls} py-2 text-xs`} type="number" value={p.durata_giorni} title="Durata in giorni" onChange={(e) => setItems(items.map((x, j) => (j === i ? { ...x, durata_giorni: e.target.value === "" ? "" : Number(e.target.value) } : x)))} />
            </div>
          </div>
        ))}
      </div>
      <div className="flex gap-2">
        <select className={`${inputCls} py-2 text-sm`} value={pick} onChange={(e) => setPick(e.target.value)} data-testid="plan-pick">
          <option value="">Aggiungi un prodotto…</option>
          {cat.filter((p) => !items.some((i) => i.codice === p.codice)).map((p) => <option key={p.codice} value={p.codice}>{p.nome}</option>)}
        </select>
        <Btn variant="dark" className="px-4" onClick={add} disabled={!pick} data-testid="plan-add"><Plus size={16} /></Btn>
      </div>
      <label className="flex items-center justify-between gap-3 rounded-2xl bg-[#0E0E10] border border-[#232328] px-3 py-2">
        <span className="text-sm text-[#9A948A]">Durata del percorso (giorni)</span>
        <input className={`${inputCls} w-24 py-1.5 text-sm text-center`} type="number" min="1" value={durata} onChange={(e) => { setDurataManual(true); setDurata(e.target.value); }} data-testid="plan-durata" />
      </label>
      <textarea className={`${inputCls} min-h-[80px] text-sm`} placeholder="Una riga tua per il cliente (es. «Parti dall'aloe al mattino, il resto lo aggiungiamo dalla seconda settimana»)" value={note} onChange={(e) => setNote(e.target.value)} data-testid="plan-note" />
      <div className="flex gap-2">
        <Btn onClick={save} disabled={busy} data-testid="plan-confirm">{busy ? "Salvo…" : "Conferma e rendi visibile"}</Btn>
        <Btn variant="ghost" onClick={onCancel}>Annulla</Btn>
      </div>
    </Card>
  );
}
